export const analyticsConfig = {
  dataLayerEnabled: true,
  gtagEnabled: false,
};
